/**
 * @name defaultLocale
 * @description The default locale of the application.
 * @type {string}
 * @default 'en'
 */
export const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE ?? 'en';
